enum LoanPayoutFigureApprovalStatusEnum {
    Approved = 'APPROVED',
    Draft = 'DRAFT',
    Legacy = 'LEGACY',
}

export default LoanPayoutFigureApprovalStatusEnum;
